import { Branch } from 'redux/modules/branches/state/initial-state';

const reducer = (state: WtrState, action: { branch: Branch }) => ({
  ...state,
  selectedBranch: action.branch,
});

export default reducer;
